<div mat-dialog-title>
    <div class='text-right line-height-0'>
      <button class="btnclose" tabindex="-1" [mat-dialog-close]></button>
    </div>
    <div class="col-12 popupTitle_rules p-0">
      <span class="col-12 p-0">{{message['subject']}}</span>
    </div>
    
  </div>
<mat-dialog-content>

  <div class="message_details justify-content-between d-flex my-3">
    <p class="mb-2 bold">Description</p>
    <p> {{message['updated'] | date : 'MMM dd, yyyy, hh:mm:ss a'}}</p>
</div>
<div class="message_details">
  <!-- <p class="bold mb-2">Description</p> -->
  <div class="message_overflow">
  <p [innerHTML]="message['message']"></p>
  </div>
</div>

  </mat-dialog-content>
  <div mat-dialog-actions class="mat-abs-footer">
    <div class="col-12 messagePaginator">
  
      <mat-paginator     [hidePageSize]="true"  [pageSizeOptions]="page.pageSizeOptions" [length]="page.limit"
        [pageSize]="page.pageSize" (page)="PageChange($event)" [pageIndex]="page.index"
        showFirstLastButtons></mat-paginator>
      </div>
  </div>